import clsx from 'clsx';
import Tag from 'components/Tag';
import { FC } from 'react';
import starlinkBg from 'assets/images/starfield_simulation.gif';
import { ReactComponent as StarlinkLogo } from 'assets/images/starlink.svg';

export enum ServiceTypeEnum {
  Broadband = 'Broadband',
  DIA = 'DIA',
  GRID = 'GRID',
  edgeboot = 'edgeboot',
  'Managed Starlink' = 'Starlink',
  'Managed Network Services' = 'MNS',
  EPIK = 'EPIK',
  'Hosted PBX' = 'Hosted PBX',
  GSE = 'GSE',
  SIP = 'SIP',
  PIP = 'PIP',
  'MS Teams Operator Connect' = 'OC MS Teams',
}

export const mapServiceTypeToTag = (type: ServiceType) => {
  const _type = ServiceTypeEnum[type as keyof typeof ServiceTypeEnum];
  return _type ?? type;
};

interface ServiceTypeProps {
  type: ServiceType;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
}

export type ServiceType =
  | 'Broadband'
  | 'DIA'
  | 'GRID'
  | 'Starlink'
  | 'Mobility'
  | 'edgeboot'
  | 'MNS'
  | 'EPIK'
  | 'Hosted PBX'
  | 'GSE'
  | 'SIP'
  | 'PIP'
  | 'OC MS Teams';

const ServiceTypeTag: FC<ServiceTypeProps> = ({
  type,
  disabled,
  className,
  labelClassName,
}) => {
  if (type === 'Starlink') return <StarlinkTag disabled={disabled} />;
  return (
    <Tag
      content={{ type: 'label', label: type }}
      status="custom"
      lableClassName={clsx('truncate', labelClassName)}
      className={clsx('text-content-tag-default', className, {
        // access
        'bg-accent-green':
          type === 'Broadband' ||
          type === 'DIA' ||
          type === 'GRID' ||
          type === 'GSE' ||
          type === 'PIP',
        // mobility
        'bg-blue-400': type === 'Mobility',
        // mns
        'bg-purple-300': type === 'edgeboot' || type === 'MNS',
        // voice
        'bg-orange-300':
          type === 'EPIK' ||
          type === 'Hosted PBX' ||
          type === 'SIP' ||
          type === 'OC MS Teams',
        //
        '!bg-neutral-500': disabled,
      })}
    />
  );
};

export default ServiceTypeTag;

const StarlinkTag: FC<Pick<ServiceTypeProps, 'disabled'>> = ({ disabled }) => {
  return (
    <div
      className="flex h-6 items-center justify-center rounded-lg bg-neutral-500 px-2 py-2 text-xs font-bold"
      style={
        !disabled
          ? {
              borderRadius: '8px',
              background: `url(${starlinkBg}) center / cover no-repeat`,
            }
          : undefined
      }
    >
      <StarlinkLogo
        className={clsx(
          'flex aspect-[17/2] h-[8px] w-[68px] shrink-0 items-center justify-center',
          disabled && 'invert',
        )}
      />
    </div>
  );
};
